import { render, staticRenderFns } from "./Guide4App.vue?vue&type=template&id=27c2822c&scoped=true"
import script from "./Guide4App.vue?vue&type=script&lang=js"
export * from "./Guide4App.vue?vue&type=script&lang=js"
import style0 from "./Guide4App.vue?vue&type=style&index=0&id=27c2822c&prod&lang=css"
import style1 from "./Guide4App.vue?vue&type=style&index=1&id=27c2822c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2822c",
  null
  
)

export default component.exports